<template>
  <div class="organ container-fuild" style="min-width:1200px;">
    <div style="padding: 0px 0 50px 0">  
        <div class="title">金融机构<span class="title-eng">FINANCIAL INSTITUTION</span></div>
        <!-- 机构 Logo 列表 - 双向滚动 -->
        <div class="organ-scroll-container">
          <!-- 第一行：向左滚动 -->
          <div class="organ-scroll-row scroll-left">
            <div class="scroll-track">
              <div
                class="organ-item"
                v-for="(item, idx) in organList.slice(0, 10)"
                :key="'left-' + idx"
              >
                <imageView v-if="item.image" :value="item.image" cusStyle="width: 271px; height: 70px;"></imageView>
              </div>
              <!-- 复制一份用于无缝滚动 -->
              <div
                class="organ-item"
                v-for="(item, idx) in organList.slice(0, 10)"
                :key="'left-copy-' + idx"
              >
                <imageView v-if="item.image" :value="item.image" cusStyle="width: 271px; height: 70px;"></imageView>
              </div>
            </div>
          </div>

          <!-- 第二行：向右滚动 -->
          <div class="organ-scroll-row scroll-right">
            <div class="scroll-track">
              <div
                class="organ-item"
                v-for="(item, idx) in organList.slice(10, 20)"
                :key="'right-' + idx"
              >
                <imageView v-if="item.image" :value="item.image" cusStyle="width: 271px; height: 70px;"></imageView>
              </div>
              <!-- 复制一份用于无缝滚动 -->
              <div
                class="organ-item"
                v-for="(item, idx) in organList.slice(10, 20)"
                :key="'right-copy-' + idx"
              >
                <imageView v-if="item.image" :value="item.image" cusStyle="width: 271px; height: 70px;"></imageView>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="page" v-show="pagination.total >20">
          <el-pagination
            layout="total, sizes,prev, pager, next, jumper"
            :page-sizes="[ 20, 50, 100]"
            :current-page.sync="pagination.page"
            :page-size.sync="pagination.size"
            :total="pagination.total"
            @current-change="getOrganArr"
            @size-change="queryOrganData"
          />
        </div> -->
      </div>
  </div>
</template>
  
<script>
import { getOrganList } from "@/api";
import imageView from ".././imageView.vue";
export default {
  name: "organ",
  components: { imageView },
  data () {
    return {
       baseUrl: process.env.VUE_APP_IMG_API,
      organList: [],
      searchOrgan: "",
      pagination: {
        page: 1,
        size: 100,
        total: 0,
      },
    }
  },
  methods: {
    async getOrganArr () {
      const res = await getOrganList({
        qymc:this.searchOrgan,
        current: this.pagination.page,
        size: this.pagination.size,
      });
      if (res && res.data) {
        this.organList = res.data.records;
        this.pagination.total = res.data.total
      }
    },
    queryOrganData () {
      this.pagination.page = 1;
      this.getOrganArr();
    }
  },
  mounted () {
    this.getOrganArr();

  }
}

</script>
<style scoped>
.organ {
}
.organ .title {
  font-size: 26px;
  font-weight: bold;
  text-align: center;
  padding: 35px 0;
  letter-spacing: 0.3px;
}
.title-eng {
  color: #cecdcd;
  margin-left: 20px;
}
.organ .content {
  margin-left: 200px;
}

.bannerImg img {
  width: 100%;
}
.bannerImg .info {
  color: #fff;
  position: absolute;
  top: -80%;
  left:40%;
  transform: translateY(-50%);
}
.bannerImg .info h3 {
  font-size: 36px;
  margin-bottom: 20px;
}
.organ-scroll-container {
  width: 1500px;
  min-height: 420px;
  margin: 0 auto;
  overflow: hidden;
}

.organ-scroll-row {
  width: 100%;
  overflow: hidden;
  margin-bottom: 20px;
}

.organ-scroll-row:last-child {
  margin-bottom: 0;
}

.scroll-track {
  display: flex;
  gap: 36px;
  width: fit-content;
}

/* 向左滚动 */
.scroll-left .scroll-track {
  animation: scrollLeft 80s linear infinite;
}

/* 向右滚动 */
.scroll-right .scroll-track {
  animation: scrollRight 80s linear infinite;
}

/* 鼠标悬停时暂停动画 */
.organ-scroll-row:hover .scroll-track {
  animation-play-state: paused;
}

/* 向左滚动动画 */
@keyframes scrollLeft {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* 向右滚动动画 */
@keyframes scrollRight {
  0% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(0);
  }
}

.organ-item {
  flex-shrink: 0;
  width: 271px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.page {
  text-align: right;
  margin-top: 25px;
  padding-right: 15%;
}
@media screen and (max-width: 767px) {
  .organ .content {
    margin-left: 0;
  }
  .organ .container {
    margin-top: 0px;
  }
  
  .bannerImg img {
    height: 176px;
  }
  .bannerImg .info {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .bannerImg .info h3 {
    font-size: 20px;
  }
}
</style>